export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Resize-Gray-14e12cd31c4798cc54b592fe6b8d202b.svg";